export const SystemMainPalette: any = {
    0: '#FFFFFF',
    1: '#787B80',
    2: '#FF493D',
    3: '#F5B800',
    4: '#43C464',
    5: '#1970ff',
}

export const SystemMainBorderPalette: any = {
    0: '#FFFFFF',
    1: '#686D75',
    2: '#E0372C',
    3: '#E5AC00',
    4: '#39B458',
    5: '#0068FF',
}